'use client'
import { Location } from '@/payload-types'
import { useState } from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../shadcn/select'

export default function Locations({ locations, messageFee }: { locations: Location[]; messageFee?: string | null }) {
	const [currentLocation, setCurrentLocation] = useState(locations[0] || null)
	const [selectedSublocation, setSelectedSublocation] = useState<{ name: string; fee?: number | null; id?: string | null } | null>(null)

	const handleChangeLocation = (value) => {
		locations.forEach((location) => {
			if (location.id === value) {
				setCurrentLocation(location)
				setSelectedSublocation(null) // Reset sublocation when location changes
			}
		})
	}

	const handleChangeSublocation = (value) => {
		const sublocation = currentLocation?.sublocations?.find((sub, index) => 
			sub.id === value || (sub.id == null && String(index) === value)
		)
		setSelectedSublocation(sublocation || null)
	}

	return (
		<>
			<p className="font-bold">Choisissez le lieu</p>
            <Select onValueChange={handleChangeLocation} defaultValue={currentLocation?.id}>
                <SelectTrigger className='w-full'>
                    <SelectValue placeholder='Sélectionner le lieu' />
                </SelectTrigger>
                <SelectContent>
                    {locations?.map((location, index) => (
                        <SelectItem key={index} value={location.id}>
                            {location.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
            <Select onValueChange={handleChangeSublocation} disabled={!currentLocation}>
                <SelectTrigger className='w-full'>
                    <SelectValue placeholder='Sélectionner' />
                </SelectTrigger>
                <SelectContent>
                    {currentLocation?.sublocations?.map((sublocation, index) => (
                        <SelectItem key={sublocation.id || index} value={sublocation.id || String(index)}>
                            {sublocation.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
			{selectedSublocation && selectedSublocation.fee != null && (
				<div className="mt-2">
					{messageFee ? (
						<p className="text-sm text-gray-600" dangerouslySetInnerHTML={{ __html: messageFee.replace(/::fee::/g, `<strong>${selectedSublocation.fee}</strong>`) }} />
					) : (
						<p className="text-sm text-gray-600">
							Frais de livraison : <span className="font-semibold">{selectedSublocation.fee} CFA</span>
						</p>
					)}
				</div>
			)}
		</>
	)
}
